export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5419.58b059e2.jpg";